export default __webpack_public_path__ + "static/media/third.0f0a30a5.jpg";